'use client';

import { useEffect } from 'react';
import SessionInfo from '../_bs-components/SessionInfo';
import { SectionContainer } from '../component/SectionContainer';
import { ForumItem } from '../type';
import customEvents from '../utils/customEvents';

export default function MeetingAgendaSection({
  data,
  title,
}: {
  data: ForumItem[];
  title: string;
}) {
  const handleScrollForumModule = ({
    isSubForum,
  }: {
    isSubForum?: boolean;
  }) => {
    const forumEle = document.querySelector(`.sessionInfoModule`);
    const id = isSubForum ? data[1]?.id : data[0]?.id;
    customEvents.emit('onSwitchForumTab', { id });
    forumEle?.scrollIntoView({
      behavior: 'smooth',
    });
  };
  useEffect(() => {
    customEvents.on('onScrollForumModule', handleScrollForumModule);
    return () => {
      customEvents.off('onScrollForumModule', handleScrollForumModule);
    };
  }, []);

  return (
    <SectionContainer
      title={title}
      className="sessionInfoModule"
      titleClassName="mobile:!mb-4"
      contentClassName="mobile:!px-0"
    >
      <SessionInfo forumList={data}></SessionInfo>
    </SectionContainer>
  );
}
